import * as React from 'react'
import { ColorUtils } from '../ColorUtils'
import { styled } from '../styled-components'

interface IProps {
  label?: string
  value: boolean
  onChange?: (value: boolean) => void
  small?: boolean
}

export const SwitchControl = (props: IProps) => {
  const { value, label, onChange, small } = props

  return (<Container onClick={() => onChange && onChange(!value)}>
    <Control {...{ value, small }} />
    {label && <Label {...{ small }}>{label}</Label>}
  </Container>)
}

const Container = styled.div`
  display: flex;
  align-items: center;
`

const Control = styled.div<{ value?: boolean, small?: boolean }>`
  position: relative;
  width: ${props => props.small ? '30px' : '50px'}; 
  height: ${props => props.small ? '16px' : '27px'};
  border-radius: ${props => props.small ? '15px' : '25px'};
  background: rgba(${props => props.value 
    ? ColorUtils.hexToRGB(props.theme.primaryColor)
    : props.theme.borderColorRGB}, 0.36);
  padding: ${props => props.small ? '1px' : '2px'};
  cursor: pointer;
  transition: background 0.3s ease-out;
  margin-right: 15px;
  flex-shrink: 0;
  &:after {
    position: absolute;
    content: '';
    display: block;
    width: ${props => props.small ? '14px' : '23px'};
    height: ${props => props.small ? '14px' : '23px'};
    background: ${props => props.value
      ? props.theme.primaryColor
      : props.theme.borderColor};
    transition: all 0.3s ease-out;
    border-radius: 50%;
    left: ${props => props.small ? '1px' : '2px'};
    ${props => props.value && `left: ${props.small ? '15px' : '25px'}`};
  }
`
const Label = styled.div<{ small?: boolean }>`
  font-size: ${props => props.small ? '12px' : '14px'};
`
